import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isNil, last, map, get } from 'lodash';
import moment from 'moment'
import cn from 'classnames';
import { isDark } from '../../utils/color';

import * as actions from '../../actions';
import { isOnTopEnd, isOnBottomEnd } from '../../utils/scrollUtil.js';

import {
  TextCell,
  ImageCell,
  PDFCell,
  LargeImageCell,
  ButtonCell,
  CarouselCell,
  FormCell,
  VideoCell,
  AudioCell,
  WaitCell,
  SystemCell
} from './chat-cells';
import { scrollToBottom } from '../../utils/scrollToBottom';

export class ChatBody extends React.Component {
  constructor(props) {
    super(props);
    this.isInit = true;
    // this.handleScroll = this.handleScroll.bind(this);
    // this.handleMobileScroll = this.handleMobileScroll.bind(this);
    this.deltaY = 0;
  }
  scrollToBottom({ animate: animate, callback: callback = () => { } }) {
    const { chatBody } = this;
    scrollToBottom(chatBody, callback)
  }
  // handleScroll = (e)=> {
  //   const isOnEnd = isOnTopEnd(this.chatBody, e.deltaY) || isOnBottomEnd(this.chatBody, e.deltaY);
  //   // not to bother horizontal scrolling: ie) carousel slider
  //   const isHorizontal = Math.abs(e.deltaY) === 0 && Math.abs(e.deltaX) > 0;
  //   if (isOnEnd && !isHorizontal) {
  //     e.preventDefault();
  //   }
  // }
  // handleMobileScroll(e) {
  //   const deltaY = this.deltaY - e.touches[0].pageY;
  //   if (isOnTopEnd(this.chatBody, deltaY) || isOnBottomEnd(this.chatBody, deltaY)) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //   }
  //   this.deltaY = e.touches[0].pageY;
  // }
  componentDidMount() {
    // // Disable touch scroll check since it was blocking scroll on carousel.
    // // To deal with it properly is kind of takes time and gives overhead,
    // // so just disabling it should be enough for now
    // this.chatBody.addEventListener('touchmove', this.handleMobileScroll);
    // this.chatBody.addEventListener('wheel', this.handleScroll);
    this.scrollToBottom({ animate: true });
  }
  // componentWillUnmount () {
  // this.chatBody.removeEventListener('touchmove', this.handleMobileScroll);
  // this.chatBody.removeEventListener('wheel', this.handleScroll);
  // }

  getIconSrc(e) {
    const { botSrcDef, botSrc1, botSrc2, botSrc3, clientSrc, operatorSrc } = this.props;
    if (isNil(e.iconType)) return '';

    switch (e.iconType) {
      case 'bot_1':
        return botSrc1;
      case 'bot_2':
        return botSrc2;
      case 'bot_3':
        return botSrc3;
      case 'bot_default':
        return botSrcDef;
      case 'operator':
        return operatorSrc;
      case 'client':
        return clientSrc;
      default:
        return '';
    }
  }

  getLastBotIconSrc() {
    const { botSrcDef, messages } = this.props;
    const lastBotMessage = last(messages.filter((m) => m.isBot && m.iconSrc));
    if (!lastBotMessage) {
      return botSrcDef;
    }

    return this.getIconSrc(lastBotMessage);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { messages, isWaitMessageShown, scrolling, scrollFinished } = this.props;

    if (
      // Should scroll only when messages are added
      messages.length !== prevProps.messages.length ||
      // Streaming message appended
      (messages[messages.length - 1]?.streaming && !messages[messages.length - 2]?.streaming) ||
      // Or waitMessage is toggled
      isWaitMessageShown !== prevProps.isWaitMessageShown
    ) {
      if (scrolling) {
        this.scrollToBottom({ animate: false, callback: scrollFinished });
      } else {
        this.scrollToBottom({ animate: true });
      }
    }

    this.isInit = false;
  }

  setRef(el) {
    this.chatBody = el;
    if (this.props.reference) {
      this.props.reference(el);
    }
  }

  render() {
    const {
      canUnfurl, messages, baseParams, withoutDate, showWait,
      isWaitMessageShown,
      enableMobileTextCopy, onOpenModalDialog, systemMessages, fontSize,
    } = this.props;

    const bodyClassName = cn('cu-ui-chat-body', {
      'cu-ui-chat-body--on-dark': isDark(baseParams.bodyBackgroundColor),
      'cu-ui-font-size-default': fontSize === 'default',
      'cu-ui-font-size-large': fontSize === 'large',
      'cu-ui-font-size-small': fontSize === 'small',
    });
    const bodyStyle = {
      backgroundColor: baseParams.bodyBackgroundColor
    };

    return (
      <div ref={el => this.setRef(el)}
        className={bodyClassName}
        style={bodyStyle}
        onTouchStart={(e) => { this.deltaY = e.touches[0].pageY; }}
        onTouchEnd={() => { this.deltaY = 0; }}
      >
        {
          map(messages, (e, idx) => {
            const commonProps = {
              key: `${e.type}-${idx}-${e.id}`,
              index: idx,
              baseParams: baseParams,
              iconSrc: this.getIconSrc(e),
              isBot: e.isBot,
              isContinuous: e.isBot === get(messages, `[${idx + 1}].isBot`),
              withIcon: e.withIcon,
              time: e.time,
              withoutDate: withoutDate,
              textCountMax: e.text_count_max,
              textCountMin: e.text_count_min,
              autoFocus: e.auto_focus,
              systemMessages
            };
            const mobileTextCopyProps = {
              enableMobileTextCopy: enableMobileTextCopy,
              onOpenModalDialog: onOpenModalDialog,
            };
            const isLast = messages.length - 1 === idx;

            switch (e.type) {
              case 'text':
                return <TextCell {...commonProps} {...mobileTextCopyProps} text={e.text} canUnfurl={canUnfurl} />;
              case 'normal-image':
                return <ImageCell {...commonProps} url={e.url} additional_url={e.additional_url} />;
              case 'large-image':
                return <LargeImageCell {...commonProps} url={e.url} additional_url={e.additional_url} />;
              case 'pdf':
                return <PDFCell {...commonProps} fileName={e.fileName} url={e.url} additional_url={e.additional_url} />;
              case 'button':
                return (
                  <ButtonCell
                    {...commonProps}
                    {...mobileTextCopyProps}
                    text={e.text}
                    buttons={e.buttons}
                    buttonLayoutType={e.buttonType}
                    canUnfurl={canUnfurl}
                    buttonLabelAlign={baseParams.buttonLabelAlign}
                  />
                );
              case 'carousel':
                return <CarouselCell {...commonProps} carousels={e.carousels} />;
              case 'video':
                return <VideoCell {...commonProps} url={e.url} />;
              case 'audio':
                return <AudioCell {...commonProps} url={e.url} />;
              case 'location':
                if (e.success) {
                  return <TextCell {...commonProps} text={systemMessages.sentLocationSuccess} />;
                } else {
                  return <TextCell {...commonProps} text={systemMessages.sentLocationFail} />;
                }
              case 'form':
                return <FormCell
                  {...commonProps}
                  disabled={e.formData.contentUpdatable ? false : !isLast}
                  isUpdateForm={e.formData.contentUpdatable && !isLast}
                  formKey={commonProps.key}
                  formData={e.formData}
                />;
              case 'system':
                return <SystemCell {...commonProps} text={e.text} />;
            }
          })
        }

        {isWaitMessageShown && (
          <TextCell
            isBot={true}
            baseParams={baseParams}
            withoutDate={withoutDate}
            time={moment(new Date).format('HH:mm')}
            key='__wait-message-cell__'
            iconSrc={this.getLastBotIconSrc()}
            text={systemMessages.waitingServerResponse}
          />
        )}

        {showWait && (
          <WaitCell
            isBot={true}
            baseParams={baseParams}
            withoutDate={withoutDate}
            time={moment(new Date).format('HH:mm')}
            key='__wait-cell__'
            iconSrc={this.getLastBotIconSrc()}
          />
        )}
      </div>
    );
  }
}

ChatBody.propTypes = {
  messages: PropTypes.array,
  scrolling: PropTypes.bool,
  scrollFinished: PropTypes.func
};

const mapStateToProps = (state, props) => ({
  canUnfurl: state.chatRoot.canUnfurl,
  messages: state.chatBody.messages,
  baseParams: state.chatRoot.baseParams,
  scrolling: state.chatBody.scrolling,
  withoutDate: state.chatRoot.withoutDate,
  showWait: state.inputField.showWait,
  enableMobileTextCopy: state.chatRoot.enableMobileTextCopy,
  isWaitMessageShown: state.chatRoot.isWaitMessageShown,
  waitMessage: state.chatRoot.waitMessage,
  clientSrc: state.chatRoot.clientSrc,
  operatorSrc: state.chatRoot.operatorSrc,
  botSrcDef: state.chatRoot.botSrcDef,
  botSrc1: state.chatRoot.botSrc1,
  botSrc2: state.chatRoot.botSrc2,
  botSrc3: state.chatRoot.botSrc3,
  systemMessages: state.chatRoot.systemMessages,
  fontSize: state.chatRoot.fontSize,
});

const mapDispatchToProps = (dispatch) => {
  return {
    scrollFinished: bindActionCreators(actions.scrollFinished, dispatch),
    onOpenModalDialog: bindActionCreators(actions.openModalDialog, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatBody);
